module.exports = __webpack_public_path__ + "img/title-@3x.5da9450f.png";